import { Box, Center } from "@chakra-ui/react";
import React, { useEffect } from "react";

const LandingPage: React.FC = ({ children }) => {
    useEffect(() => {
        const redirectUrl = process.env.REACT_APP_TELESHENDET_SIGAL_URL;
        if (process.env.REACT_APP_TELESHENDET_SIGAL_URL) {
            window.location.assign(redirectUrl);
        }
    }, []);

    return (
        <Center>
            <Box marginTop="20px">Duke ridrejtuar...</Box>
        </Center>
    );
};

export default LandingPage;
